import lottie from 'lottie-web';
import AbstractComponent from "./abstract-component";

export default class SiteLoader extends AbstractComponent {
    constructor(app) {
        super(app);
        this.initDomElements();
        this.init();
    }
    initDomElements() {
        this.DOM = { player: this.$el.querySelector('.player') };
    }
    init() {
        this.lottie = lottie.loadAnimation({
            container: this.DOM.player,
            renderer: 'svg',
            loop: false,
            autoplay: true,
            path: this.$el.getAttribute('data-json')
        });
        this.lottie.addEventListener('complete', () => {
            this.$el.classList.add('transiting');
            setTimeout(() => {
                this.$el.classList.add('loaded');
                window.dispatchEvent(new CustomEvent('site-loader:done'));
            }, 1000);
        });
    }
    destroy() {
        this.lottie?.destroy?.();
        this.lottie = null;
    }
}
